export default {
  data() {
    return {
      fieldsValidation: []
    };
  },

  methods: {
    registerField(vmField) {
      if (vmField.hasValidateConfig) {
        if (!vmField.hasName) {
          console.warn(
            "You must set property name to use validation.",
            vmField
          );
          return false;
        }
        this.$validator.attach({
          name: vmField.name,
          rules: vmField.validationConfig,
          alias: vmField.fieldAlias
        });
        this.fieldsValidation.push({ key: vmField.name, vm: vmField });
        return true;
      }
      return false;
    },

    validate() {
      return this.$validator.validateAll(this.fieldValues);
    },

    clear() {
      this.fieldsValidation.forEach(({ key, vm }) => {
        vm.localValue = null;
      });
    }
  },

  computed: {
    fieldValues() {
      var values = {};
      this.fieldsValidation.forEach(({ key, vm }) => {
        values[key] = vm.localValue;
      });
      return values;
    }
  }
};
